import { makeVar } from '@apollo/client'

export const isWalletsDialogOpenVar = makeVar(false)
